import React, { useRef,useState } from "react";
import { createPortal } from "react-dom";
import { ArrowUpDown } from "lucide-react";

import { useClickOutside } from "components/ui/DataTable/hooks/useClickOutside";
import { useDropdownPosition } from "components/ui/DataTable/hooks/useDropdownPosition";

import styles from "./DataTableSort.module.css";

export const DataTableSort = ({
  sort,
  sortOptions = [],
  onSortChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  const { position, updatePosition } = useDropdownPosition(
    buttonRef,
    isOpen,
    { align: "right", menuWidth: 220 }
  );

  useClickOutside(isOpen, buttonRef, menuRef, () => setIsOpen(false));

  if (!sortOptions.length) return null;

  const handleToggle = () => {
    if (!isOpen) updatePosition();
    setIsOpen(!isOpen);
  };

  const handleSelect = (field, direction) => {
    onSortChange?.(field, direction);
    setIsOpen(false);
  };

  return (
    <>
      <div className={styles.sortButtonWrapper}>
        <button
          ref={buttonRef}
          className={`${styles.sortButton} ${isOpen ? styles.active : ""}`}
          onClick={handleToggle}
        >
          Sort by
          <ArrowUpDown size={18} className={styles.sortIcon} />
        </button>
      </div>
      {isOpen &&
        createPortal(
          <div
            ref={menuRef}
            className={styles.dropdown}
            style={{ position: "fixed", top: position.top, left: position.left }}
          >
            {sortOptions.map((opt) => {
              const isActive =
                sort?.field === opt.field && sort?.direction === opt.direction;
              const Icon = opt.icon;
              return (
                <button
                  key={`${opt.field}-${opt.direction}`}
                  className={`${styles.dropdownItem} ${isActive ? styles.dropdownItemActive : ""}`}
                  onClick={() => handleSelect(opt.field, opt.direction)}
                >
                  {Icon && (
                    <span className={styles.dropdownItemIcon}>
                      <Icon size={16} />
                    </span>
                  )}
                  {opt.label}
                </button>
              );
            })}
          </div>,
          document.body
        )}
    </>
  );
};
